import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Tabs,
  Tab,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GeneralTab from './GeneralTab';
import MasterStatTab from './MasterStatTab';
// CalcAccountTab is disabled pre-launch — re-enable post-launch
// import CalcAccountTab from './CalcAccountTab';
import ProFormaTab from './ProFormaTab';
import './projectSettingsModal.scss';

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      className="tab-panel"
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function ProjectSettingsModal({ 
  open, 
  onClose, 
  isDataFullyLoaded, 
  initialTab = 0,
  exportButtonEnabled,
  exportFileLoading,
  onExportData,
  onOpenGLKeyManagement,
}) {
  const [activeTab, setActiveTab] = useState(initialTab);
  const dialogContentRef = React.useRef(null);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    
    // Scroll to top of dialog content when tab changes
    if (dialogContentRef.current) {
      dialogContentRef.current.scrollTop = 0;
    }
  };

  // Reset to initial tab when modal opens
  React.useEffect(() => {
    if (open) {
      setActiveTab(initialTab);
      // Scroll to top when modal opens
      if (dialogContentRef.current) {
        dialogContentRef.current.scrollTop = 0;
      }
    }
  }, [open, initialTab]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      className="project-settings-modal"
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          Project Settings & Actions
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <Box className="modal-tabs">
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="General" />
          <Tab label="Master Stats" />
          {/* Calculated Accounts tab disabled pre-launch — re-enable post-launch */}
          {/* <Tab label="Calculated Accounts" /> */}
          <Tab label="Pro Forma" />
        </Tabs>
      </Box>

      <DialogContent ref={dialogContentRef}>
        <TabPanel value={activeTab} index={0}>
          <GeneralTab 
            isDataFullyLoaded={isDataFullyLoaded}
            exportButtonEnabled={exportButtonEnabled}
            exportFileLoading={exportFileLoading}
            onExportData={onExportData}
            onClose={onClose}
            onOpenGLKeyManagement={onOpenGLKeyManagement}
          />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <MasterStatTab isDataFullyLoaded={isDataFullyLoaded} />
        </TabPanel>
        {/* Calculated Accounts tab panel disabled pre-launch */}
        {/* <TabPanel value={activeTab} index={2}>
          <CalcAccountTab isDataFullyLoaded={isDataFullyLoaded} onClose={onClose} />
        </TabPanel> */}
        <TabPanel value={activeTab} index={2}>
          <ProFormaTab isDataFullyLoaded={isDataFullyLoaded} onClose={onClose} />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}
